import { Button, Dialog } from '@material-ui/core'
import React, { useCallback } from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import { useNewQuestionnaire } from '../../customHooks/useNewQuestionnaire'

export const NewQuestionnaireDialog = ({ open, setOpen }) => {
  const newQuestionnaire = useNewQuestionnaire()

  const handleClose = useCallback(() => setOpen(false), [setOpen])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        Do you want to create a new questionnaire?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          Are you sure you want to create a new questionnaire? You will loose
          all the local changes that have not been saved to the server.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id='noToNew' onClick={handleClose} color='primary'>
          No
        </Button>
        <Button
          id='yesToDelete'
          onClick={() => {
            handleClose()
            newQuestionnaire()
          }}
          color='primary'
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}
